import groq from 'groq';

import { MEDIA } from './media';
import { OVERLINE } from './overline';

export const HERO_CAROUSEL = groq`
  heroCarousel[] {
    _key,
    ${OVERLINE},
    title,
    subtitle,
    link,
    ${MEDIA},
    bulletPoints
  }
`;
